import { memo, FC } from 'react';

import { MassMessageEntityWithRecipients } from 'models';

import { Centered, Loader, Error, NoData } from 'components';
import RecipientsEntity from './recipients-entity';

import { useStyles } from './style';

interface RecepientsDetailsProps {
  recipientsEntities: MassMessageEntityWithRecipients[] | undefined;
  loading: boolean;
  error: boolean;
}

const RecepientsDetails: FC<RecepientsDetailsProps> = ({
  recipientsEntities,
  loading,
  error,
}) => {
  const classes = useStyles();

  if (loading) {
    return (
      <Centered>
        <Loader themeColor={'darkBlue'} />
      </Centered>
    );
  }

  if (error) {
    return <Error />;
  }

  if (!recipientsEntities || !recipientsEntities.length) {
    return <NoData />;
  }

  return (
    <div className={classes.root}>
      {recipientsEntities.map((entity) => (
        <RecipientsEntity key={entity.Id} entity={entity} />
      ))}
    </div>
  );
};

export default memo(RecepientsDetails);
